import React from "react";
import { ComponentExt } from "@src/utils/reactExt";
import * as styles from "./styles/index.scss"
import magicBaygiftbg from "@assets/img/magicBay/magicBayGiftbg.png"
import magicBayButton from "@assets/img/magicBay/magicBayGiftButton.png"
import magicBaySuccess from "@assets/img/magicBay/magicBaySuccess.png"
import { createForm } from 'rc-form';
import { isValidImei } from "@utils/index"
class Gift extends ComponentExt<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            info: '',
            color: '',
            success: false,
            remainingCycle: '',
            resDetailRecord: [],
            modelName: []
        }
    }
    doSubmit = () => {
        this.props.form.validateFields(async (error, value) => {
            this.setState({ info: '', color: '' })
            if (error) {
                const imeiField = error.imei as any
                let msg = ''
                if (imeiField) {
                    if (Array.isArray(imeiField) && imeiField[0]) {
                        msg = imeiField[0].message
                    } else if (
                        !Array.isArray(imeiField) &&
                        imeiField.errors &&
                        imeiField.errors[0]
                    ) {
                        const e = imeiField.errors[0]
                        msg = e.message || String(e)
                    }
                }
                if (msg) {
                    this.setState({ info: msg, color: '' })
                }
                return
            }
            const imei = (value.imei || '').trim()
            try {
                this.setState({ info: '', color: '' })
                this.$toast.loading('领取中，请稍后', 15)
                await this.api.magicRecordImei({ imei})
                this.setState({ success: true })
                this.$toast.hide()
            } catch (error) {
            }
        })
    };
    render(): React.ReactNode {
        const { getFieldProps } = this.props.form;
        return (
            <div className={styles.giftWrapper}>
                <img className={styles.bgImage} src={magicBaygiftbg} alt="" />
                <div className={styles.pageContent}>
                <div className={styles.content}>
                    <div >

                        {
                            !this.state.success &&
                            <>
                                <div className={styles.inputItem}>
                                    <input
                                        type="tel"
                                        {...getFieldProps('imei', {
                                            normalize: (v) =>
                                                String(v || '')
                                                    .replace(/\D/g, '')
                                                    .slice(0, 15),
                                            rules: [
                                                {
                                                    validator: (_rule, val, callback) => {
                                                        const v = (val || '').trim()
                                                        if (!v) {
                                                            callback(new Error('请输入设备IMEI码'))
                                                            return
                                                        }
                                                        if (!isValidImei(v)) {
                                                            callback(new Error('请输入正确的设备IMEI码'))
                                                            return
                                                        }
                                                        callback()
                                                    }
                                                }
                                            ]
                                        })}
                                        maxLength={15}
                                        inputMode="numeric"
                                        placeholder="请输入设备IMEI码"
                                        style={{ textAlign: 'center' }}
                                    />
                                </div>
                                <p className={styles.giftInfo} style={{ color: this.state.color || 'red' }}>{this.state.info}</p>
                                <div className={styles.btn} style={{ backgroundImage: `url(${magicBayButton})` }} onClick={this.doSubmit}></div>
                            </>
                        }
                        {
                            this.state.success && <>
                                <img src={magicBaySuccess} style={{ width: '50%', marginBottom: '20px' }} alt="" />
                            </>
                        }
                    </div>
                </div>
                </div>
            </div>
        )
    }
}
export default createForm()(Gift)